import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import Hero from './Components/Hero';
import Tabs from './Components/Tabs';
import Tab2 from './Components/Tab2';
 class Layanan extends Component {
  render() {
    return (
      <div className="term-condition">
       <Hero
       title="Kebijakan "
       subtitle="Kebijakan Deliv dalam pembuatan aplikasi"
       />
       <Tabs></Tabs>
       <Tab2></Tab2>
      </div>
    )
  }
}

export default Layanan;